import { isPositionClientError } from '../position-error';

const MAX_PICKER_RETRIES = 2;

export const retryPickerQuery = (failureCount: number, error: Error): boolean =>
    failureCount < MAX_PICKER_RETRIES && !isPositionClientError(error);
